export default function highlightCurrentDays() {
  const date = new Date();

  const dayHighlights = document.querySelectorAll(`[data-highlight-today="${date.getDay()}"]`);

  dayHighlights.forEach(element => {
    element.classList.add(element.dataset['highlight-class'] || 'active');
  });
}
